<template>
  <div>
    <vs-popup title="URL do Vídeo (YouTube)" :active.sync="videoPopup">
      <div class="vs-alert" style="background-color: rgba(var(--vs-primary),.15); color: rgb(111, 38, 224);">
        <p>
          Muitos clientes de e-mail não mostram o vídeo embutido na mensagem, portanto, 
          ao adicionar a URL de um vídeo, ficará assim:
        </p>

        <p>
          <strong>*|YOUTUBE:[$vid=123456]|*</strong>
        </p>

        <br />

        <p>
          Não remova esse código do vídeo, pois quando o assinante receber o e-mail, 
          este código será substituído e ficará assim:
        </p>

        <br />

        <img src="https://eep.io/images/yzco4xsimv0y/L5Xa1nnLieUSGWi08MI02/b239ff2fc5c882617802503ad41226ed/youtube-example.png" />
      </div>

      <vs-input
        v-model="videoUrl"
        class="w-full mt-5"
        name="videoUrl"
        placeholder="URL do vídeo"
      />

      <vs-button
        class="mt-5 float-right"
        :disabled="videoUrl === ''"
        @click="handleVideo"
      >
        Confirmar
      </vs-button>
    </vs-popup>

    <form class="form form-vertical">
      <div class="form-body">
        <div class="row">
          <!-- Nome -->
          <vx-input-group class="mb-base">          
            <vs-input
              label="Nome"
              v-model="templateData.name"
              class="w-full"
              name="name"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('name')"
            >
              {{ errors.first('name') }}
            </span>
          </vx-input-group>

          <!-- Content -->
          <vx-input-group class="mb-base">
            <vs-input 
              type="file" 
              @change="handleImages" 
              id="selectFile" 
              hidden
              accept="image/jpeg, image/png"
            />
            <button
              type="button"
              id="selectVideo"
              @click="handleVideoClick"
              style="display: none;"
            ></button>
            <label class="vs-input--label">Conteúdo do Template</label>         
            <quill-editor
              v-model="templateData.content"
              :options="editorOptions"
              class="w-full"
              rows="10"
              name="content"
              id="content"
              v-validate="'required'"
              ref="quillEdit"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('content')"
            >
              {{ errors.first('content') }}
            </span>
          </vx-input-group>

          <!-- Activated -->
          <vx-input-group class="mb-base" v-if="templateData.id">
            <vs-checkbox
              v-model="templateData.activated"
              class="custom-control-label"
              name="activated"
            >
              Ativo
            </vs-checkbox>
          </vx-input-group>

          <!-- Submit -->
          <vx-input-group>
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
              Salvar
            </vs-button>
          </vx-input-group>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  import { quillEditor } from 'vue-quill-editor'
  import toolbarOptions from '@/utils/defaultToolbarOptions'

  import moduleTemplate from '@/store/newsletter/template/moduleTemplate'
  import {
    encodeToBase64,
    decodeFromBase64,
    detectAndRemoveFileFromBucket,
    uploadFile
  } from '@/utils'

  export default {
    name: 'newsletter-template-form',
    props: {
      template: {
        type: Object,
        required: false,
        default: () => {
          return {
            id: null,
            name: '',
            content: '',
            activated: true
          }
        }
      }
    },
    data() {
      return {
        templateData: {},
        editorOptions: {
          theme: "snow",
          placeholder: "Conteúdo do template...",
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                image: function() {
                  document.getElementById('selectFile').click()
                },
                video: function() {
                  document.getElementById('selectVideo').click()
                }
              }
            }
          }
        },
        videoPopup: false,
        videoUrl: '',
        quillEditorRange: 0
      }
    },
    watch: {
      videoPopup(videoPopup) {
        if (!videoPopup) {
          this.videoUrl = ''
        }
      }
    },
    computed: {
      isFormValid() {
        return !this.errors.any()
      }
    },
    methods: {
      handleVideoClick() {
        this.quillEditorRange = this.$refs.quillEdit.quill.getSelection().index
        this.videoPopup = true
      },
      handleVideo () {
        this.videoPopup = false
        let videoUrl = this.videoUrl.split('/')
        videoUrl = videoUrl[videoUrl.length - 1]

        if (videoUrl.includes('v=')) {
          videoUrl = videoUrl.split('v=')[1]
        }

        this.$refs.quillEdit.quill.insertText(
          this.quillEditorRange,
          `*|YOUTUBE:[$vid=${videoUrl}]|*`,
          'user'
        )
      },
      /**
       * Detect if image was removed to delete it from Amazon S3
       */
      onTextChange(delta, oldDelta) {
        detectAndRemoveFileFromBucket(oldDelta, this.$refs.quillEdit)
      },
      handleImages(e) {
        uploadFile(e).then(uploadedImage => {
          const range = this.$refs.quillEdit.quill.getSelection()
          this.$refs.quillEdit.quill.insertEmbed(range.index , 'image', uploadedImage.fileUrl)
        })
      },
      setTemplateData(data) {
        this.templateData = this.$_.cloneDeep(data)
        this.templateData.content = decodeFromBase64(this.templateData.content);
      },
      submitData() {
        const templateData = this.$_.cloneDeep(this.templateData);
        templateData.content = encodeToBase64(templateData.content);
        
        this.$validator.validateAll().then(result => {
          if (result) {
            if (templateData.id !== null && templateData.id >= 0) {
              // Edit
              this.$store.dispatch("newsletterTemplate/update", templateData).then(() => {
                // Redirect to list page
                this.$router.push("/newsletter/templates/list")
              }).catch(err => {
                console.error(err)
              })
            } else {
              // New
              delete templateData.id
              delete templateData.activated
              this.$store.dispatch("newsletterTemplate/add", templateData).then(() => {
                // Redirect to list page
                this.$router.push("/newsletter/templates/list")
              }).catch(err => {
                console.error(err)
              })
            }
          }
        })
      }
    },
    async created() {
      this.setTemplateData(this.template);

      if (!moduleTemplate.isRegistered) {
        this.$store.registerModule('newsletterTemplate', moduleTemplate)
        moduleTemplate.isRegistered = true
      }

      const templateId = this.$route.params.id;

      // The following logic will only work on "update" page
      if (templateId) {
        await this.$store.dispatch("newsletterTemplate/infos", templateId)
        this.setTemplateData(this.$store.state.newsletterTemplate.templateInfos);
      }
    },
    mounted() {
      this.$refs.quillEdit.quill.on("text-change", this.onTextChange);
    },
    components: {
      quillEditor,
      VuePerfectScrollbar
    }
  }
</script>